<div class="v-one-card-header">
  <div class="v-one-card-header__row">
    <div class="v-one-card-header__content">
      @if (getChipConfig(); as chip) {
        @if (chip.indicatorColor) {
          <span
            class="v-one-card-header__divider"
            [style.background-color]="chip.indicatorColor"
          ></span>
        }
        @if (chip.title) {
          <span class="v-one-card-header__title">{{
            chip.title | translate
          }}</span>
        }
        <v-one-chips-tags
          class="v-one-card-header__status-chip"
          [label]="chip.label"
          [type]="'tag'"
          [tagState]="chip.tagState"
          [showIcon]="false"
          [compact]="true"
        />
      } @else {
        @if (icon) {
          <span
            class="v-one-card-header__divider"
            [style.background-color]="indicatorColor"
          ></span>
          <v-one-icon
            [name]="icon"
            [color]="iconColor"
            class="v-one-card-header__icon"
          />
        }
        <div class="v-one-card-header__info">
          @if (title) {
            <span class="v-one-card-header__title">{{
              title | translate
            }}</span>
          }
        </div>
      }

      @if (getNoteChips().length > 0) {
        <div class="v-one-card-header__notes">
          @for (chip of getNoteChips(); track chip.label) {
            <v-one-chips-tags
              [label]="chip.label"
              [type]="'tag'"
              [tagState]="chip.tagState"
              [showIcon]="false"
              [compact]="true"
            />
          }
        </div>
      }
    </div>

    @if (showMenu && menuOptions.length > 0) {
      <div class="v-one-card-header__actions">
        <v-one-menu-dropdown
          [options]="menuOptions"
          [menuPosition]="'right'"
          (optionSelected)="handleMenuSelect($event)"
        />
      </div>
    }
  </div>

  @if (isPortfolioCard() && getDisplayConsecutives().length > 0) {
    <div class="v-one-card-header__codes-section">
      @for (
        code of getDisplayConsecutives();
        track code.value;
        let i = $index
      ) {
        <div
          class="v-one-card-header__code-item"
          [class.v-one-card-header__code-item--first]="i === 0"
          [class.v-one-card-header__code-item--middle]="
            i > 0 && i < getDisplayConsecutives().length - 1
          "
          [class.v-one-card-header__code-item--last]="
            i === getDisplayConsecutives().length - 1
          "
          [class.v-one-card-header__code-item--highlighted]="
            isHighlighted(code)
          "
        >
          <span class="v-one-card-header__code-value"
            >{{ code.boldPrefix }}{{ code.value }}</span
          >
        </div>
      }
    </div>
    <div class="v-one-card-header__codes-divider"></div>
  }
</div>
